import { render, staticRenderFns } from "./ComboTable.vue?vue&type=template&id=086a230e&scoped=true"
import script from "./ComboTable.vue?vue&type=script&lang=js"
export * from "./ComboTable.vue?vue&type=script&lang=js"
import style0 from "./ComboTable.vue?vue&type=style&index=0&id=086a230e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a230e",
  null
  
)

export default component.exports